import { render, staticRenderFns } from "./DocSolutionPage.vue?vue&type=template&id=7bfdc925"
import script from "./DocSolutionPage.vue?vue&type=script&lang=js"
export * from "./DocSolutionPage.vue?vue&type=script&lang=js"
import style0 from "./DocSolutionPage.vue?vue&type=style&index=0&id=7bfdc925&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports